import { render, staticRenderFns } from "./PostingUpdate.vue?vue&type=template&id=8e8755da"
import script from "./PostingUpdate.vue?vue&type=script&lang=js"
export * from "./PostingUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports